const EnvironmentVariables = Object.freeze(
    {
        MARKETING_BASE_URL: process.env.REACT_APP_MARKETING_BASE_URL,
        VCS_PORTAL_BASE_URL: process.env.REACT_APP_VCS_PORTAL_BASE_URL,
        RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
        GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
        ENVIRONMENT: process.env.ENVIRONMENT
    }
);

export default EnvironmentVariables;